module.exports = __webpack_public_path__ + "img/kartapolis-white.0e1dc7d.svg";